// Mission status display config — shared by the Dispatch register and the
// truck planner board (extracted from Dispatch.tsx so the board's chunk
// doesn't pull in the 4.8k-line page).
import { statusTone } from '@/lib/statusTone'

export type MissionStatus = 'DRAFT' | 'LOADING' | 'READY' | 'DISPATCHED' | 'CANCELLED'

// Words only — the colour is the status tone (@/lib/statusTone, <StatusPill object="mission"/>).
export const MISSION_STATUS_CFG: Record<MissionStatus, { label: string }> = {
  DRAFT:      { label: statusTone('mission', 'DRAFT').label },
  LOADING:    { label: statusTone('mission', 'LOADING').label },
  READY:      { label: statusTone('mission', 'READY').label },
  DISPATCHED: { label: statusTone('mission', 'DISPATCHED').label },
  CANCELLED:  { label: statusTone('mission', 'CANCELLED').label },
}

/** A truck still at the packhouse — the statuses the Home tile counts
 *  (get_inventory_pulse `missions_in_progress`) and the calendar's "Truck
 *  load" arm lists (mig 20261020130000). Dispatch's Today view reads the same
 *  set, so the three never disagree about which trucks are open. */
export const OPEN_MISSION_STATUSES: readonly MissionStatus[] = ['DRAFT', 'LOADING', 'READY']

export function isOpenMission(status: MissionStatus): boolean {
  return OPEN_MISSION_STATUSES.includes(status)
}
